/**
 * @ngdoc services
 * @memberof mercury.services
 * @name logging
 * @description Logging service that only writes to the browser console if
 *   logging has been enabled by first setting a local storage key with the
 *   name '@@loaded/debugEnabled' to a truthy value.
 */
angular.module('mercury.services.logging', [])
.factory('logger', ["$window", "$log", function($window, $log) {

  // Note not using `localStorageService` here so we can strictly
  // define the key  name we want to look for.
  var enabled = $window.localStorage.getItem('@@loaded/debugEnabled');

  function wrapLogger(logger) {
    return function() {
      if (enabled) {
        logger.apply(this, arguments);
      }
    };
  }

  return {
    debug: wrapLogger($log.debug),
    error: wrapLogger($log.error),
    info: wrapLogger($log.info),
    warn: wrapLogger($log.warn)
  };
}]);
